import script from "./RepartitionSurface.vue?vue&type=script&setup=true&lang=js"
export * from "./RepartitionSurface.vue?vue&type=script&setup=true&lang=js"

import "./RepartitionSurface.vue?vue&type=style&index=0&id=75c18059&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75c18059"]])

export default __exports__